/** The queue's two tabs. The value is what appears in the `?tab=` query param. */
export enum DocumentReviewTab {
  Contractor = 'contractor',
  MasterContractor = 'master-contractor',
}

export enum ContractorQueueFields {
  driverName = 'driverName',
  partnerName = 'partnerName',
  type = 'type',
  finishedAt = 'finishedAt',
  slpRate = 'slpRate',
}

export enum McQueueFields {
  partnerId = 'partnerId',
  type = 'type',
  status = 'status',
  finishedAt = 'finishedAt',
}

/**
 * Master-contractor rejection reasons are static — there is no MC rejection-reasons endpoint, so
 * unlike the contractor queue these are not fetched. Values are the wire values the Retool app
 * sent; the backend stores `declineReason` as a free string and does not validate them.
 */
export enum McRejectionReason {
  Expired = 'expired',
  InformationMismatch = 'information_mismatch',
  Invalid = 'invalid',
  FailedBackgroundCheck = 'failed_bg_check',
  NotOwnerOfInsurance = 'not_owner_of_insurance',
  WrongCountry = 'wrong_country',
  DocumentUnreadable = 'document_unreadable',
  InformationMissing = 'information_missing',
  NameMissing = 'name_missing',
  PasswordProtected = 'password_protected_file',
}

/** para-node `CollectDataDriverLicenseType`, read from the collected data's `metadata`. */
export enum DriverLicenseType {
  Standard = 'standard',
  Temporary = 'temporary',
}

/** para-node `AiDocumentReviewReasonCode` — why an AI review reached its decision. */
export enum AiDocumentReviewReasonCode {
  DocumentTypeMismatch = 'document_type_mismatch',
  DocumentIllegible = 'document_illegible',
  RequiredFieldsMissing = 'required_fields_missing',
  DocumentExpired = 'document_expired',
  DocumentNotYetEffective = 'document_not_yet_effective',
  PolicyHolderMismatch = 'policy_holder_mismatch',
  NamedPartyMismatch = 'named_party_mismatch',
  HolderSelectionRejected = 'holder_selection_rejected',
  DeclaredValueMismatch = 'declared_value_mismatch',
  OperatingStatusNotActive = 'operating_status_not_active',
  BackgroundCheckNotClear = 'background_check_not_clear',
  BackgroundCheckRecordsFound = 'background_check_records_found',
  VehicleVinMismatch = 'vehicle_vin_mismatch',
  VehicleDetailsMismatch = 'vehicle_details_mismatch',
  VehicleVinPartial = 'vehicle_vin_partial',
  RegistrationStickerNoOwner = 'registration_sticker_no_owner',
  CrossDocumentVinMismatch = 'cross_document_vin_mismatch',
  PartnerRuleFailed = 'partner_rule_failed',
  PartnerRulesNotFound = 'partner_rules_not_found',
  LowConfidence = 'low_confidence',
  ReviewFailed = 'review_failed',
}
